import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of, EMPTY } from 'rxjs';
import { take, mergeMap } from 'rxjs/operators';

import { ContextPromotions } from '../../_models/promotions/context.promotions';
import { PromotionService } from '../../_services/promotion.service';


@Injectable({
  providedIn: 'root'
})
export class PromotionsDataResolverService  {

  constructor(
    private promotionService: PromotionService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ContextPromotions> | Observable<never> {

    return this.promotionService.getContext(false).pipe(
      take(1),
      mergeMap(ctx => {
        if (ctx) {
          return of(ctx);
        } else { // no data?
          return EMPTY;
        }
      })
    );

  }

}
